import * as React from 'react'
import { ClickAwayListener } from '@mui/material'

interface IOwnProps {
  onClickOutside: () => void
  className?: string
  children?: React.ReactNode
}

// Drop-in replacement for the legacy `react-click-outside` (which used findDOMNode,
// deprecated under React 18). Closes on any click outside its subtree. Without a
// className the wrapper is display:contents so it adds no box to the layout (headers
// rely on the trigger staying a direct flex child); with one it renders a real div.
const ClickOutside: React.FunctionComponent<IOwnProps> = ({
  onClickOutside,
  className,
  children,
}) => (
  <ClickAwayListener onClickAway={onClickOutside}>
    <div
      className={className}
      style={className ? undefined : { display: 'contents' }}
    >
      {children}
    </div>
  </ClickAwayListener>
)

export default ClickOutside
